<script>
import { QIcon as QuasarQIcon } from 'quasar'
import { inject, getCurrentInstance, h } from 'vue'

export default {
  name: 'QIcon',
  props: QuasarQIcon.props,
  emits: QuasarQIcon.emits,
  setup(props, ctx) {
    // Try inject first (works during SSR and client)
    // Fall back to getCurrentInstance().proxy.$q
    let $q
    try {
      $q = inject('_q_', null) || getCurrentInstance()?.proxy?.$q
    } catch {
      $q = null
    }

    if ($q) {
      // Quasar is properly initialized — render original QIcon
      return () => h(QuasarQIcon, props, ctx.slots)
    }

    // Fallback: render a plain <i> that mimics QIcon's basic behavior
    const name = props.name || ''
    const classes = ['q-icon', 'notranslate']

    if (name) {
      // Handle common Quasar icon prefixes
      if (name.startsWith('img:')) {
        return () => h('img', {
          src: name.slice(4),
          class: 'q-icon notranslate',
          style: props.size ? { width: props.size, height: props.size } : {},
          alt: '',
          'aria-hidden': 'true',
        })
      }

      if (name.startsWith('svg:')) {
        return () => h('i', {
          class: [...classes, 'svg-icon'],
          style: props.size ? { fontSize: props.size } : {},
          'aria-hidden': 'true',
        }, name.slice(4))
      }

      if (name.startsWith('mat') || name.startsWith('sym_')) {
        classes.push('material-symbols-outlined')
      } else if (name.startsWith('fas ') || name.startsWith('far ') || name.startsWith('fab ') || name.startsWith('fa ')) {
        classes.push(...name.split(' '))
      } else {
        classes.push(name)
      }
    }

    if (props.color) {
      classes.push(`text-${props.color}`)
    }
    if (props.left) {
      classes.push('on-left')
    }
    if (props.right) {
      classes.push('on-right')
    }

    const style = {}
    if (props.size) {
      style.fontSize = props.size
    }

    return () => h('i', {
      class: classes,
      style,
      'aria-hidden': 'true',
      role: 'img',
    }, name && !name.startsWith('fas ') && !name.startsWith('far ') && !name.startsWith('fab ') && !name.startsWith('fa ') ? name : undefined)
  },
}
</script>
